<div class="fx-row-start-center">
    <div class="date-row">
      <app-date-selection (dateChange)="onDateChange($event)"></app-date-selection>
    </div>
</div>
    
<div class="chart-main">
  <div id="paretoChart" *ngIf="showChart">
      <div echarts [options]="chartOption" class="pareto-echart"></div>
  </div>
</div>

<div *ngIf="!showChart" class="no-data">
  <h5>No Data</h5>
</div>
